import { useMutation } from "urql";

import { RejectLimitRequestByRrDocument } from "../../../graphql/generated.ts";

export const useRejectLimitRequestByRR = () =>
  useMutation(RejectLimitRequestByRrDocument);
